<template>
  <div>
    <q-dialog
      v-model="opened"
      stack-buttons
      prevent-close
      @cancel="opened = false">
      <q-card>
        <!-- This or use "title" prop on <q-dialog> -->
        <q-card-section class="text-h6">Groeidocument openen</q-card-section>

        <!-- This or use "message" prop on <q-dialog> -->
        <q-card-section>
          Enkele momenten geduld, het Groeidocument wordt voor u klaargezet.
        </q-card-section>

        <q-card-section horizontal>
          <q-linear-progress
            :value="progress"
            :buffer="buffer"
            style="height: 10px"
          />

        </q-card-section>

        <q-card-actions align="right">
          <div class="row justify-end gutter-sm">
            <div>
              <q-btn flat label="Terug" @click="opened = false" data-cy="groeidocument-btn-back"/>
            </div>

            <div>
              <q-btn color="primary" label="Openen" :loading="loading" @click="okClicked" data-cy="groeidocument-btn-open"/>
            </div>
          </div>
        </q-card-actions>

      </q-card>
    </q-dialog>
  </div>
</template>

<script>
  import { QBtn, QDialog, QLinearProgress } from 'quasar'

  export default {
    name: 'NoTaskDialog',
    components: {
      QDialog,
      QLinearProgress,
      QBtn
    },
    methods: {
      okClicked (cb) {
        this.resolve()
        // this.$emit('open-task', this.form)
        const tasks = this.$store.getters['groups/getTasks']
        const task = tasks.find(t => t.fid === this.form.fid)
        this.opened = false
        this.formViewerReference.open(task.link.replace(/http(s)?/, 'https'))

        setTimeout(cb, 500)
      },
      show (form, formViewerReference) {
        this.form = form
        this.formViewerReference = formViewerReference
        this.opened = true
        this.loading = true
        this.promise = new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
        return this.promise
      }
    },
    computed: {
      progress () {
        return this.$store.state.groups.taskProgress
      },
      loading () {
        return this.progress !== 100
      }
    },
    data () {
      return {
        buffer: 1,
        formViewerReference: {},
        opened: false,
        resolve: () => {
        },
        reject: () => {
        },
        promise: new Promise(() => {
        })
      }
    }
  }
</script>

<style scoped>

</style>
